export enum RoomAgentMode {
    SIP = 'sip',
    BROADCAST = 'broadcast',
}
